/**
 * Theme scripts.
 *
 * Every .js file directly inside src/js/ is transpiled, concatenated and
 * minified into js/main.min.js. Third-party libraries go in src/js/plugins/
 * instead, and end up in js/plugins.min.js.
 */
(() => {
	const onReady = (fn) => {
		if (document.readyState !== 'loading') {
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	};

	onReady(() => {
		// Add a class once the page has scrolled, for a compact sticky header.
		const header = document.getElementById('masthead');

		if (!header) {
			return;
		}

		const onScroll = () => {
			header.classList.toggle('is-scrolled', window.scrollY > 24);
		};

		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
	});
})();
